module.exports = __webpack_public_path__ + "img/logo.45fcc00b.png";